import { MEAL_GOAL_DEFS } from './meal-goals.types';
/**
 * Loss-day classifier definition derived from {@link MEAL_GOAL_DEFS}.
 * Used by the meal classifier for coach-facing accuracy (off-plan, admin grid) —
 * not for client-side gating or coaching UI.
 */
export function lossDayClassifierDefinition() {
    const { intent, expectations } = MEAL_GOAL_DEFS.loss;
    const rules = expectations.join('; ');
    return `- loss: ${intent.toLowerCase()}; ${rules}; grilled/baked/steamed prep; light dressings/sauces; avoids fried/breaded/creamy/cheesy/sugary elements.`;
}
/**
 * Guidance lines for the classifier when interpreting ambiguous meals on loss days.
 */
export const LOSS_DAY_CLASSIFIER_GUIDANCE = [
    'On loss days (per program): meals with starch, grains, rice, potatoes, bread, pasta, or tortillas are NOT loss — classify maintenance unless clearly indulgent (then reward).',
    'Strong lean protein + vegetables with no starch/grain -> loss.',
    'Salads with lean protein and vegetables are loss unless creamy dressing, fried protein, or starch-heavy add-ons.',
    'Very small portions of otherwise indulgent foods can still be loss when quantity is clearly minimal; starch/grain portions are never loss on program loss days.',
    'Bowls/sandwiches/pasta/wraps default to maintenance or reward unless clearly lean protein + veg only with no starch.',
];
